import { useTranslation } from 'react-i18next';

export default function FinalCTASection() {
  const { t } = useTranslation();

  return (
    <section className="relative py-20 md:py-28 overflow-hidden">
      <div className="absolute inset-0 bg-secondary-950" />
      <div className="absolute inset-0 opacity-10">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20fashion%20texture%20pattern%20warm%20neutral%20tones%20subtle%20elegant%20minimal%20background%20editorial%20style%20soft%20lighting&width=1600&height=900&seq=cta-bg&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
      </div>
      <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-2xl md:text-4xl text-background-50 mb-5">
          {t('finalCtaH2')}
        </h2>
        <p className="text-background-200/80 mb-8 max-w-xl mx-auto leading-relaxed">
          {t('finalCtaText')}
        </p>
        <a
          href="https://kaspreadsheet.com"
          target="_blank"
          rel="noopener nofollow"
          className="inline-flex items-center gap-2 px-8 py-4 text-base font-medium bg-primary-500 text-white rounded-xl hover:bg-primary-600 transition-colors shadow-lg shadow-primary-500/25 whitespace-nowrap"
        >
          {t('finalCtaButton')}
          <i className="ri-arrow-right-line" style={{ width: 18, height: 18 }} />
        </a>
      </div>
    </section>
  );
}